import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { AgGridReact } from 'ag-grid-react';

import { Drawer } from 'antd';

const height = window.innerHeight * .60;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const columnDefs = [
    { headerName: 'Date', field: 'Date', filter: 'agTextColumnFilter', width: 60 },
    { headerName: 'Old Price', field: 'OldValue', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 25, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'New Price', field: 'NewValue', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 25, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
];

class PriceDrawer extends Component {

    constructor(props) {
        super(props);
        
        this.store = props.store;
    }

    close = () => {
        this.store.closeDrawer();
    }

    render() {
        const title = "Price History for Referrer ID: " + this.store.referrerId;
        const priceList = this.store.priceHistory;
        
        return (
            <Drawer title={title} width={"50%"} closable={true} onClose={this.close} visible={this.store.isDrawerOpened} destroyOnClose>
                 <div className="ag-theme-alpine" style={{ height: height, width: '100%',backgroundColor: 'white' }}>
                        <AgGridReact
                            ref={this.gridRef}
                            defaultColDef={defaultColDef}
                            rowData={priceList}
                            columnDefs={columnDefs}
                            enterMovesDown={true}
                            enterMovesDownAfterEdit={true}
                            rowHeight={25}
                        >
                        </AgGridReact>
                    </div>
            </Drawer>
        )
    }
}

export default observer(PriceDrawer);
